export default "__VITE_ASSET__Dvvk51Q$__"